import { render, staticRenderFns } from "./CategoryTypeSelect.vue?vue&type=template&id=09ae398a&scoped=true&"
import script from "./CategoryTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./CategoryTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ae398a",
  null
  
)

export default component.exports